import React from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import { Link } from '../buttons';
import { Checkbox } from '../checkbox';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const CheckboxStyled = styled(Checkbox)`
    align-items: start;
`;

const DetailP = styled.p`
    line-height: 12px;
    text-align: justify;
    font-size: 10px;
    font-weight: 400;
    color: #414042;
`;

interface GeneralConditionsAndMarketingProps {
    className?: string;
    isGeneralConditionsChecked?: boolean;
    isThirdPartyChecked?: boolean;
    generalConditionsLabel?: React.ReactNode;
    thirdPartyLabel?: React.ReactNode;
    setIsGeneralConditionsChecked?: (value: boolean) => void;
    setIsThirdPartyChecked?: (value: boolean) => void;
}

const GeneralConditionsAndMarketing = ({
    className,
    isGeneralConditionsChecked,
    isThirdPartyChecked,
    generalConditionsLabel,
    thirdPartyLabel,
    setIsGeneralConditionsChecked,
    setIsThirdPartyChecked
}: GeneralConditionsAndMarketingProps) => {
    const [isDetailVisible, setIsDetailVisible] = React.useState(false);

    return (
        <Container className={className ?? ''}>
            {isGeneralConditionsChecked != undefined && setIsGeneralConditionsChecked != undefined && (
                <CheckboxStyled
                    checked={isGeneralConditionsChecked || false}
                    onChange={(checked) => setIsGeneralConditionsChecked(checked)}
                    label={
                        generalConditionsLabel ?? (
                            <span>
                                {T._('By registering you declare that you have read and fully accepted our', 'Admin')}{' '}
                                <Link target='_blank' href='https://www.zakeke.com/privacy-policy-platform/#general-conditions'>
                                    {/* Non deve essere tradotto nelle varie lingue */}
                                    General Conditions
                                </Link>{' '}
                                {T._('of use and that you have read our', 'Admin')}{' '}
                                <Link target='_blank' href='https://www.zakeke.com/privacy-policy-platform/#privacy-policy'>
                                    {/* Non deve essere tradotto nelle varie lingue */}
                                    Privacy Policy
                                </Link>{' '}
                                {T._('and the', 'Admin')}{' '}
                                <Link target='_blank' href='https://www.zakeke.com/privacy-policy-platform/#cookie-policy'>
                                    {/* Non deve essere tradotto nelle varie lingue */}
                                    Cookie Policy
                                </Link>
                                .
                            </span>
                        )
                    }
                />
            )}
            {isThirdPartyChecked != undefined && setIsThirdPartyChecked != undefined && (
                <CheckboxStyled
                    checked={isThirdPartyChecked || false}
                    onChange={(checked) => setIsThirdPartyChecked(checked)}
                    label={
                        thirdPartyLabel ?? (
                            <div>
                                <span>
                                    {T._('Consent for the processing of data with Marketing Puroposes.', 'Admin')}{' '}
                                    <a
                                        style={{ verticalAlign: 'unset' }}
                                        href='#'
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setIsDetailVisible(!isDetailVisible);
                                        }}
                                    >
                                        {T._('Details', 'Admin')}
                                    </a>
                                </span>
                                {isDetailVisible && (
                                    <DetailP>
                                        {T._(
                                            `I consent to the processing of my data for advertising, promotional and marketing activities (including the sending of newsletters and advertising material on products and services offered by UpCommerce). You can withdraw your consent at any time by sending an e-mail to the address: privacy@upcommerce.com or through the unsubscribe at the bottom of the e-mail.`,
                                            'Admin'
                                        )}
                                    </DetailP>
                                )}
                            </div>
                        )
                    }
                />
            )}
        </Container>
    );
};

export default GeneralConditionsAndMarketing;
